/**
 * Goal authorship badge + edit rules, shared by the student / parent / teacher
 * program views.
 *
 * `student_goals.created_by_type` has no 'admin' member, so a kurum/admin
 * "Toplu Hedef Atama" writes 'system'. Before that existed every call site did
 * a bare `created_by_type === 'teacher'` test, which quietly bucketed a
 * kurum-assigned goal as the student's own — mislabelling it AND handing the
 * student a delete button for it. The rule is now: anything that is not
 * 'student' was assigned from above and the student may not remove it.
 */
export type GoalAuthor = string | undefined | null;

export const isSelfSetGoal = (t: GoalAuthor): boolean => t === 'student' || t == null;

export interface GoalBadge { text: string; bg: string; fg: string }

export const goalAuthorBadge = (t: GoalAuthor): GoalBadge =>
  t === 'teacher' || t === 'coach'
    ? { text: 'Öğretmen Hedefi', bg: '#f5c518', fg: '#1a1a1a' }
    : t === 'system'
      ? { text: 'Kurum Hedefi', bg: '#7b5cd6', fg: '#fff' }
      : { text: 'Öğrenci Hedefi', bg: '#3973bf', fg: '#fff' };
